import { USER_REJECTED_TXN_ERR_MESSAGES } from './constants';
export const didUserRejectTxnSigning = (error) => {
    const { message } = error;
    return USER_REJECTED_TXN_ERR_MESSAGES.includes(message);
};
